(function () {
  // ✅ يشتغل فقط على صفحات /ar
  function isArabicPage() {
    return window.location.pathname.startsWith("/ar");
  }

  // English -> Arabic
  var COLOR_MAP = {
    "Black": "أسود",
    "Gold": "ذهبي",
    "Grey": "رمادي",
    "Gray": "رمادي",
    "Silver": "فضي",
    "White": "أبيض",
    "Red": "أحمر",
    "Blue": "أزرق",
    "Green": "أخضر",
    "Brown": "بني",
    "Beige": "بيج",
    "Pink": "وردي",
    "Purple": "بنفسجي",
    "Navy": "كحلي"
  };

  function isColorFieldset(fs) {
    if (!fs || fs.tagName !== "FIELDSET") return false;
    return !!fs.querySelector('input[type="radio"][name="Color"]');
  }

  function updateSelectedText(fieldset) {
    var selectedSpan = fieldset.querySelector('span[data-selected-swatch-value]');
    if (!selectedSpan) return;

    var checked = fieldset.querySelector('input[type="radio"][name="Color"]:checked');
    if (!checked) return;

    var en = (checked.value || "").trim();
    var ar = COLOR_MAP[en] || en;
    selectedSpan.textContent = " " + ar;
  }

  function translateFieldset(fieldset) {
    if (!isColorFieldset(fieldset)) return;

    // عنوان "Color :" -> "اللون :"
    var headerLabel = fieldset.querySelector(".form__label");
    if (headerLabel && !headerLabel.dataset.doneTitle) {
      if (headerLabel.childNodes[0]) headerLabel.childNodes[0].nodeValue = "اللون : ";
      headerLabel.dataset.doneTitle = "1";
    }

    // label النص اللي تحت السواتشات
    fieldset.querySelectorAll("label.color_pickerVariant").forEach(function (lb) {
      var en = lb.textContent.trim();
      var ar = COLOR_MAP[en];
      if (ar) lb.textContent = ar;
    });

    // label السواتش نفسه (اللي فيه visually-hidden)
    fieldset.querySelectorAll(".pickerVariant_color > label[for]").forEach(function (lb) {
      var first = lb.childNodes[0];
      if (!first || first.nodeType !== Node.TEXT_NODE) return;

      var en = (first.nodeValue || "").trim();
      var ar = COLOR_MAP[en];
      if (ar) first.nodeValue = ar + " ";
    });

    updateSelectedText(fieldset);

    if (!fieldset.dataset.boundChange) {
      fieldset.addEventListener("change", function (e) {
        if (e.target && e.target.matches('input[type="radio"][name="Color"]')) {
          updateSelectedText(fieldset);
        }
      });
      fieldset.dataset.boundChange = "1";
    }
  }

  function run() {
    if (!isArabicPage()) return;

    document.querySelectorAll("fieldset.product-form__input").forEach(function (fs) {
      translateFieldset(fs);
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    run();

    // لو Shopify أعاد رسم الجزء
    var observer = new MutationObserver(function (mutations) {
      if (!isArabicPage()) return;

      mutations.forEach(function (m) {
        m.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;

          if (node.matches && node.matches("fieldset.product-form__input")) {
            translateFieldset(node);
          }

          if (node.querySelectorAll) {
            node.querySelectorAll("fieldset.product-form__input").forEach(function (fs) {
              translateFieldset(fs);
            });
          }
        });
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
  });



  // Filter 

  // Shopify Filter Dropdown Converter - Version 2.0
  (function () {
    'use strict';

    // Configuration
    const CONFIG = {
      filterName: 'filter.p.m.custom.size_text',
      dropdownClass: 'custom-size-dropdown',
      dropdownId: 'size-filter-dropdown',
      debug: true
    };

    // Log function for debugging
    function log(...args) {
      if (CONFIG.debug) {
        console.log('[Size Filter Dropdown]', ...args);
      }
    }

    // Error logging
    function logError(...args) {
      console.error('[Size Filter Dropdown ERROR]', ...args);
    }

    // Wait for element to exist
    function waitForElement(selector, timeout = 5000) {
      return new Promise((resolve, reject) => {
        const startTime = Date.now();

        function check() {
          const element = document.querySelector(selector);
          if (element) {
            resolve(element);
            return;
          }

          if (Date.now() - startTime > timeout) {
            reject(new Error(`Timeout waiting for element: ${selector}`));
            return;
          }

          setTimeout(check, 100);
        }

        check();
      });
    }

    // Get all size filter checkboxes
    function getSizeCheckboxes() {
      return document.querySelectorAll(`input[name="${CONFIG.filterName}"]`);
    }

    // Find the facet container
    function findFacetContainer() {
      // Try multiple selectors to find the facet container
      const selectors = [
        '#Facet-8-template--17369556418619__product-grid',
        '[id*="Facet-8"]',
        'form[action*="filter"]',
        '.facets__form',
        'form[action*="/collections/"]'
      ];

      for (const selector of selectors) {
        const element = document.querySelector(selector);
        if (element) {
          log(`Found facet container with selector: ${selector}`);
          return element;
        }
      }

      return null;
    }

    // Hide original radio buttons
    function hideOriginalCheckboxes(checkboxes) {
      if (checkboxes.length === 0) return;

      const container = checkboxes[0].closest('ul, .facets__list, .list-unstyled, .facets__items');
      if (container) {
        container.style.display = 'none';
        log('Hidden original checkboxes container');
      }

      // Also hide the label/heading if it exists
      const heading = checkboxes[0].closest('details')?.querySelector('summary') ||
        checkboxes[0].closest('.facets__item')?.querySelector('.facets__summary');
      if (heading && heading.textContent.toLowerCase().includes('size')) {
        heading.closest('details')?.setAttribute('open', 'true');
      }
    }

    // Create the dropdown HTML
    function createDropdownHTML() {
      const dropdown = document.createElement('div');
      dropdown.id = CONFIG.dropdownId;
      dropdown.className = CONFIG.dropdownClass;
      dropdown.style.cssText = `
      position: relative;
      width: 100%;
      max-width: 300px;
      margin: 15px 0;
      z-index: 1000;
    `;

      dropdown.innerHTML = `
      <div class="dropdown-selected" style="
        padding: 12px 16px;
        border: 2px solid #ddd;
        border-radius: 8px;
        cursor: pointer;
        background: white;
        position: relative;
        font-size: 14px;
        color: #333;
        user-select: none;
        min-height: 44px;
        display: flex;
        align-items: center;
      ">
        <span class="selected-text">Select frame size</span>
        <span class="dropdown-arrow" style="
          position: absolute;
          right: 12px;
          top: 50%;
          transform: translateY(-50%);
          font-size: 10px;
          color: #666;
          pointer-events: none;
        ">▼</span>
      </div>
      <div class="dropdown-options" style="
        display: none;
        position: absolute;
        top: 100%;
        left: 0;
        right: 0;
        background: white;
        border: 2px solid #666;
        border-top: none;
        border-radius: 0 0 8px 8px;
        max-height: 300px;
        overflow-y: auto;
        z-index: 1001;
        box-shadow: 0 4px 12px rgba(0,0,0,0.15);
      "></div>
    `;

      return dropdown;
    }

    // Populate dropdown options
    function populateDropdownOptions(dropdown, checkboxes) {
      const optionsContainer = dropdown.querySelector('.dropdown-options');
      const selectedText = dropdown.querySelector('.selected-text');

      // Clear existing options
      optionsContainer.innerHTML = '';

      // Track current selection
      let currentSelection = 'Select frame size';

      // Add size options
      checkboxes.forEach((checkbox, index) => {
        const label = checkbox.nextElementSibling;
        const optionText = label ? label.textContent.trim() : checkbox.value;

        // Create option element
        const option = document.createElement('div');
        option.className = 'dropdown-option';
        option.dataset.index = index;
        option.dataset.value = checkbox.value;
        option.style.cssText = `
        padding: 12px 16px;
        cursor: pointer;
        font-size: 14px;
        color: #333;
        border-bottom: 1px solid #f5f5f5;
        transition: all 0.2s ease;
      `;
        option.textContent = optionText;

        // Check if this option is currently selected
        if (checkbox.checked) {
          currentSelection = optionText;
          option.style.backgroundColor = '#f0f8ff';
          option.style.fontWeight = '600';
        }

        // Hover effects
        option.addEventListener('mouseenter', function () {
          if (!checkbox.checked) {
            this.style.backgroundColor = '#f8f8f8';
          }
        });

        option.addEventListener('mouseleave', function () {
          if (!checkbox.checked) {
            this.style.backgroundColor = '';
          }
        });

        // Click handler
        option.addEventListener('click', function (e) {
          e.stopPropagation();
          handleOptionClick(checkbox, optionText, dropdown, checkboxes);
        });

        optionsContainer.appendChild(option);
      });

      // Add clear option
      const clearOption = document.createElement('div');
      clearOption.className = 'dropdown-option clear-option';
      clearOption.textContent = 'Clear selection';
      clearOption.style.cssText = `
      padding: 12px 16px;
      cursor: pointer;
      font-size: 14px;
      color: #999;
      font-style: italic;
      border-top: 2px solid #eee;
      background: #fff5f5;
      transition: all 0.2s ease;
    `;

      clearOption.addEventListener('mouseenter', function () {
        this.style.backgroundColor = '#ffe6e6';
        this.style.color = '#d00';
      });

      clearOption.addEventListener('mouseleave', function () {
        this.style.backgroundColor = '#fff5f5';
        this.style.color = '#999';
      });

      clearOption.addEventListener('click', function (e) {
        e.stopPropagation();
        clearSelection(checkboxes, dropdown);
      });

      optionsContainer.appendChild(clearOption);

      // Update selected text
      selectedText.textContent = currentSelection;
    }

    // Handle option click
    function handleOptionClick(checkbox, optionText, dropdown, allCheckboxes) {
      log(`Option clicked: ${optionText}`);

      // Uncheck all checkboxes first
      allCheckboxes.forEach(cb => {
        cb.checked = false;
        cb.removeAttribute('checked');
      });

      // Check the selected checkbox
      checkbox.checked = true;
      checkbox.setAttribute('checked', 'checked');

      // Update UI
      updateDropdownUI(dropdown, optionText, allCheckboxes);

      // Close dropdown
      const optionsContainer = dropdown.querySelector('.dropdown-options');
      const arrow = dropdown.querySelector('.dropdown-arrow');
      const selected = dropdown.querySelector('.dropdown-selected');

      optionsContainer.style.display = 'none';
      arrow.textContent = '▼';
      selected.style.borderRadius = '8px';

      // Submit the filter form
      submitFilterForm(checkbox);
    }

    // Clear selection
    function clearSelection(checkboxes, dropdown) {
      log('Clearing selection');

      // Uncheck all checkboxes
      checkboxes.forEach(cb => {
        cb.checked = false;
        cb.removeAttribute('checked');
      });

      // Update UI
      updateDropdownUI(dropdown, 'Select frame size', checkboxes);

      // Close dropdown
      const optionsContainer = dropdown.querySelector('.dropdown-options');
      const arrow = dropdown.querySelector('.dropdown-arrow');
      const selected = dropdown.querySelector('.dropdown-selected');

      optionsContainer.style.display = 'none';
      arrow.textContent = '▼';
      selected.style.borderRadius = '8px';

      // Submit the filter form to clear filter
      if (checkboxes.length > 0) {
        submitFilterForm(checkboxes[0]);
      }
    }

    // Update dropdown UI
    function updateDropdownUI(dropdown, selectedText, checkboxes) {
      const selectedTextElement = dropdown.querySelector('.selected-text');
      const options = dropdown.querySelectorAll('.dropdown-option');

      // Update selected text
      selectedTextElement.textContent = selectedText;

      // Update option styles
      options.forEach(option => {
        if (option.classList.contains('clear-option')) return;

        const index = option.dataset.index;
        const checkbox = checkboxes[index];

        if (checkbox && checkbox.checked) {
          option.style.backgroundColor = '#f0f8ff';
          option.style.fontWeight = '600';
        } else {
          option.style.backgroundColor = '';
          option.style.fontWeight = '';
        }
      });
    }

    // Submit filter form
    function submitFilterForm(checkbox) {
      // Find the form
      const form = checkbox.closest('form');
      if (!form) {
        logError('No form found for checkbox');
        return;
      }

      log('Submitting filter form');

      // Method 1: Try to find and click the submit button
      const submitButton = form.querySelector('button[type="submit"], input[type="submit"], .facets__form-submit');
      if (submitButton) {
        log('Found submit button, clicking it');
        submitButton.click();
        return;
      }

      // Method 2: If no submit button, trigger form submission manually
      log('No submit button found, triggering form submission');

      // Create and dispatch submit event
      const submitEvent = new Event('submit', {
        bubbles: true,
        cancelable: true
      });
      form.dispatchEvent(submitEvent);

      // Also trigger change event
      const changeEvent = new Event('change', {
        bubbles: true,
        cancelable: true
      });
      form.dispatchEvent(changeEvent);

      // If Shopify uses AJAX filtering, try to trigger it
      if (typeof Shopify !== 'undefined') {
        // Try different Shopify filter patterns
        if (typeof Shopify.onFilterChange === 'function') {
          Shopify.onFilterChange();
        }

        // Dispatch Shopify-specific events
        document.dispatchEvent(new CustomEvent('shopify:filter:change', {
          detail: { filter: CONFIG.filterName }
        }));
      }

      // Last resort: try actual form submission
      try {
        setTimeout(() => {
          form.submit();
        }, 100);
      } catch (e) {
        logError('Form submission failed:', e);
      }
    }

    // Setup dropdown event listeners
    function setupDropdownEvents(dropdown) {
      const selected = dropdown.querySelector('.dropdown-selected');
      const optionsContainer = dropdown.querySelector('.dropdown-options');
      const arrow = dropdown.querySelector('.dropdown-arrow');

      // Toggle dropdown
      selected.addEventListener('click', function (e) {
        e.stopPropagation();

        if (optionsContainer.style.display === 'block') {
          optionsContainer.style.display = 'none';
          arrow.textContent = '▼';
          this.style.borderRadius = '8px';
        } else {
          optionsContainer.style.display = 'block';
          arrow.textContent = '▲';
          this.style.borderRadius = '8px 8px 0 0';

          // Refresh options if needed
          const checkboxes = getSizeCheckboxes();
          if (checkboxes.length > 0) {
            populateDropdownOptions(dropdown, checkboxes);
          }
        }
      });

      // Close dropdown when clicking outside
      document.addEventListener('click', function (e) {
        if (!dropdown.contains(e.target)) {
          optionsContainer.style.display = 'none';
          arrow.textContent = '▼';
          selected.style.borderRadius = '8px';
        }
      });

      // Prevent dropdown close when clicking inside options
      optionsContainer.addEventListener('click', function (e) {
        e.stopPropagation();
      });
    }

    // Main initialization function
    async function initializeDropdown() {
      try {
        log('Starting initialization...');

        // Remove existing dropdown if it exists
        const existingDropdown = document.getElementById(CONFIG.dropdownId);
        if (existingDropdown) {
          existingDropdown.remove();
          log('Removed existing dropdown');
        }

        // Wait for checkboxes to be available
        let checkboxes;
        try {
          // Try multiple times to get checkboxes
          for (let i = 0; i < 5; i++) {
            checkboxes = getSizeCheckboxes();
            if (checkboxes.length > 0) break;

            log(`Attempt ${i + 1}: No checkboxes found, waiting...`);
            await new Promise(resolve => setTimeout(resolve, 300));
          }
        } catch (e) {
          logError('Error waiting for checkboxes:', e);
          return false;
        }

        if (checkboxes.length === 0) {
          log('No size filter checkboxes found on this page');
          return false;
        }

        log(`Found ${checkboxes.length} size checkboxes`);

        // Hide original checkboxes
        hideOriginalCheckboxes(checkboxes);

        // Create dropdown
        const dropdown = createDropdownHTML();

        // Populate options
        populateDropdownOptions(dropdown, checkboxes);

        // Setup event listeners
        setupDropdownEvents(dropdown);

        // Find where to insert the dropdown
        const facetContainer = findFacetContainer();
        if (!facetContainer) {
          logError('Could not find facet container');
          return false;
        }

        // Try to insert near the size filter
        const sizeElement = findSizeElement(facetContainer);
        const insertPosition = sizeElement || facetContainer;

        if (sizeElement) {
          sizeElement.parentNode.insertBefore(dropdown, sizeElement.nextSibling);
          log('Inserted dropdown after size element');
        } else {
          facetContainer.prepend(dropdown);
          log('Prepended dropdown to facet container');
        }

        log('Dropdown initialized successfully');
        return true;

      } catch (error) {
        logError('Initialization failed:', error);
        return false;
      }
    }

    // Find size filter element
    function findSizeElement(container) {
      // Look for elements that might indicate size filter
      const sizeIndicators = [
        'summary:contains("Size")',
        'summary:contains("size")',
        '.facets__summary:contains("Size")',
        'h3:contains("Size")',
        'h4:contains("Size")',
        'label:contains("Size")'
      ];

      for (const selector of sizeIndicators) {
        try {
          const elements = container.querySelectorAll(selector);
          for (const element of elements) {
            if (element.textContent.toLowerCase().includes('size')) {
              return element.closest('details') || element.closest('.facets__item') || element;
            }
          }
        } catch (e) {
          // Some selectors might not be valid in querySelectorAll
        }
      }

      return null;
    }

    // Global observer for Shopify AJAX updates
    let globalObserver = null;

    // Setup global mutation observer
    function setupGlobalObserver() {
      if (globalObserver) {
        globalObserver.disconnect();
      }

      globalObserver = new MutationObserver((mutations) => {
        let shouldReinitialize = false;

        for (const mutation of mutations) {
          // Check if filter-related elements were added
          if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
            for (const node of mutation.addedNodes) {
              if (node.nodeType !== 1) continue; // Not an element

              // Check if this is a filter element
              const isFilterElement =
                node.matches && (
                  node.matches('form[action*="filter"]') ||
                  node.matches('.facets__form') ||
                  node.querySelector && node.querySelector(`input[name="${CONFIG.filterName}"]`)
                );

              if (isFilterElement) {
                shouldReinitialize = true;
                break;
              }

              // Check if our dropdown was removed
              if (!document.getElementById(CONFIG.dropdownId)) {
                shouldReinitialize = true;
              }
            }
          }

          // Check if URL changed (Shopify updates URL with filters)
          if (mutation.type === 'attributes' && mutation.attributeName === 'href') {
            shouldReinitialize = true;
          }
        }

        if (shouldReinitialize) {
          log('DOM change detected, reinitializing...');
          debouncedReinitialize();
        }
      });

      // Observe the entire document
      globalObserver.observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['href', 'class', 'style']
      });

      log('Global observer started');
    }

    // Debounced reinitialization
    let reinitializeTimeout;
    function debouncedReinitialize() {
      clearTimeout(reinitializeTimeout);
      reinitializeTimeout = setTimeout(() => {
        initializeDropdown();
      }, 300);
    }

    // Listen for Shopify events
    function setupShopifyEventListeners() {
      const shopifyEvents = [
        'shopify:section:load',
        'shopify:section:unload',
        'shopify:section:reorder',
        'shopify:section:select',
        'shopify:section:deselect'
      ];

      shopifyEvents.forEach(eventName => {
        document.addEventListener(eventName, () => {
          log(`Shopify event: ${eventName}, reinitializing...`);
          setTimeout(initializeDropdown, 500);
        });
      });

      // Listen for AJAX navigation
      if (typeof Turbo !== 'undefined') {
        document.addEventListener('turbo:load', () => {
          log('Turbo load event, reinitializing...');
          setTimeout(initializeDropdown, 700);
        });
      }

      // Listen for history changes
      window.addEventListener('popstate', () => {
        log('History popstate, reinitializing...');
        setTimeout(initializeDropdown, 500);
      });
    }

    // Setup periodic check
    function setupPeriodicCheck() {
      setInterval(() => {
        const checkboxes = getSizeCheckboxes();
        const dropdown = document.getElementById(CONFIG.dropdownId);

        if (checkboxes.length > 0 && !dropdown) {
          log('Periodic check: checkboxes exist but dropdown missing, reinitializing...');
          initializeDropdown();
        } else if (dropdown && checkboxes.length === 0) {
          log('Periodic check: dropdown exists but no checkboxes, removing dropdown...');
          dropdown.remove();
        }
      }, 3000);
    }

    // Main initialization
    async function main() {
      log('Script loaded');

      // Initial setup with retry
      let initialized = false;
      let retries = 0;
      const maxRetries = 10;

      while (!initialized && retries < maxRetries) {
        initialized = await initializeDropdown();

        if (!initialized) {
          retries++;
          log(`Initialization failed, retry ${retries}/${maxRetries}...`);
          await new Promise(resolve => setTimeout(resolve, 500));
        }
      }

      if (initialized) {
        // Setup observers and listeners
        setupGlobalObserver();
        setupShopifyEventListeners();
        setupPeriodicCheck();
        log('Setup complete');
      } else {
        logError(`Failed to initialize after ${maxRetries} attempts`);
      }
    }

    // Start everything
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', main);
    } else {
      main();
    }

    // Make initializeDropdown available globally for manual calls
    window.reinitializeSizeFilter = initializeDropdown;

  })();
  //END Filter

  //Icon in Filter

  function injectFrameShapeIcons() {
    console.log('Injecting frame shape icons...');

    // Try multiple possible selectors for flexibility
    const selectors = [
      '#Facet-6-template--17369556418619__product-grid',
      '.facets-container',
      '.facets-wrapper',
      '.facets'
    ];

    let frameShapeFacetEl;
    for (const selector of selectors) {
      frameShapeFacetEl = document.querySelector(selector);
      if (frameShapeFacetEl) break;
    }

    if (!frameShapeFacetEl) {
      console.log('Facet element not found');
      return;
    }

    const iconMap = {
      cateye: 'https://cdn.shopify.com/s/files/1/0641/6780/4987/files/cateye.webp?v=1770192799',
      oval: 'https://cdn.shopify.com/s/files/1/0641/6780/4987/files/oval.webp?v=1770193011',
      pilot: 'https://cdn.shopify.com/s/files/1/0641/6780/4987/files/pilot.webp?v=1770193023',
      rectangular: 'https://cdn.shopify.com/s/files/1/0641/6780/4987/files/rectangle.webp?v=1770193033',
      round: 'https://cdn.shopify.com/s/files/1/0641/6780/4987/files/round.webp?v=1770193222',
      square: 'https://cdn.shopify.com/s/files/1/0641/6780/4987/files/square.webp?v=1770193222'
    };

    // Find all facet items, even if they're dynamically added
    const facetItems = frameShapeFacetEl.querySelectorAll('.facets__item, .filter-group__item, .js-filter');

    console.log(`Found ${facetItems.length} facet items`);

    facetItems.forEach(item => {
      const input = item.querySelector('input[type="checkbox"], input[type="radio"]');
      const textSpan = item.querySelector('.facet-checkbox__text, .filter__label span, .label');

      if (!input || !textSpan) {
        console.log('Input or textSpan not found in item', item);
        return;
      }

      const value = input.value.toLowerCase().trim();
      const iconUrl = iconMap[value];

      if (!iconUrl) {
        console.log(`No icon found for value: ${value}`);
        return;
      }

      // Remove existing icon if present
      const existingIcon = textSpan.querySelector('.facet-shape-icon');
      if (existingIcon) existingIcon.remove();

      // Create and insert icon
      const img = document.createElement('img');
      img.src = iconUrl;
      img.alt = value;
      img.className = 'facet-shape-icon';

      // Add inline styles for immediate visibility
      img.style.cssText = `
      width: 24px;
      height: 24px;
      margin-right: 10px;
      vertical-align: middle;
      display: inline-block;
      object-fit: contain;
    `;

      // Insert before the text content
      const textContent = textSpan.childNodes;
      if (textContent.length > 0 && textContent[0].nodeType === Node.TEXT_NODE) {
        textSpan.insertBefore(img, textContent[0]);
      } else {
        textSpan.prepend(img);
      }

      console.log(`Injected icon for: ${value}`);
    });
  }

  // Run immediately when DOM is loaded
  document.addEventListener('DOMContentLoaded', injectFrameShapeIcons);

  // Also run after a delay to catch dynamically loaded content
  setTimeout(injectFrameShapeIcons, 500);
  setTimeout(injectFrameShapeIcons, 1500);

  // Use a more aggressive observer for Shopify's dynamic updates
  const observeFacetChanges = () => {
    // Observer for facet container
    const observer = new MutationObserver((mutations) => {
      let shouldReinject = false;
      mutations.forEach((mutation) => {
        if (mutation.addedNodes.length) {
          shouldReinject = true;
        }
      });
      if (shouldReinject) {
        console.log('DOM changed, reinjecting icons...');
        setTimeout(injectFrameShapeIcons, 100);
      }
    });

    // Watch the entire document for facet-related changes
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  };

  // Start observing after initial load
  setTimeout(observeFacetChanges, 1000);

  // Listen for Shopify-specific events
  document.addEventListener('shopify:section:load', injectFrameShapeIcons);
  document.addEventListener('shopify:section:unload', injectFrameShapeIcons);
  document.addEventListener('shopify:section:select', injectFrameShapeIcons);
  document.addEventListener('shopify:section:deselect', injectFrameShapeIcons);

  // Listen for filter changes (common Shopify pattern)
  document.addEventListener('click', (e) => {
    if (e.target.closest('.facets__item, .js-filter, .filter-group__item')) {
      console.log('Filter clicked, will reinject icons...');
      setTimeout(injectFrameShapeIcons, 300);
    }
  });

  // Polling as a last resort (runs every 2 seconds)
  let pollingInterval;
  const startPolling = () => {
    if (pollingInterval) clearInterval(pollingInterval);
    pollingInterval = setInterval(() => {
      const hasIcons = document.querySelectorAll('.facet-shape-icon').length;
      const hasFacetItems = document.querySelectorAll('.facets__item, .filter-group__item').length;

      if (hasFacetItems > 0 && hasIcons < hasFacetItems) {
        console.log('Icons missing, reinjecting via poll...');
        injectFrameShapeIcons();
      }
    }, 2000);
  };

  setTimeout(startPolling, 2000);



  //END Icon in Filter

})();


// WhatsApp Button Begin

document.addEventListener("DOMContentLoaded", function () {
  var phone = "+201271010177"; // country code + number
  var url = window.location.href;
  var text = "Hello! I am from NOOR website:\n" + url + "\nI need help";
  var waLink = "https://wa.me/" + phone + "?text=" + encodeURIComponent(text);

  var btn = document.getElementById("waBtn");
  if (btn) {
    btn.href = waLink;
    console.log("WhatsApp button initialized successfully");
  } else {
    console.error("WhatsApp button not found!");
  }
});

// WhatsApp Button End
